import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {formatDate, parseDate} from 'common/util/date';

import {template} from './template';

export class DateInput extends Component<any, any> {
  static get observedAttributes() {
    return Component.observedAttributes.concat([`error`, `value`]);
  }

  attributeChangedCallback(attr: any, oldValue: any, newValue: any) {
    super.attributeChangedCallback(attr, oldValue, newValue);
    if (attr === `value`) {
      this.update({dateObj: parseDate(newValue)});
    }
  }

  get config() {
    return {
      template,
      defaultState: {
        dateObj: null,
      },
      helpers: {
        formatDate,
        focusedInput: () => this.emitFocus(),
        blurredInput: () => {
          this.inputEl.value = ``;
          this.emitBlur();
        },
        changedInput: (ev: any) => {
          ev.stopPropagation();
          const dateObj = this.inputEl.value.length ? parseDate(this.inputEl.value) : null;
          this.update({dateObj});
          this.emitChange();
        },
      },
    };
  }

  emitFocus() {
    this.dispatchEvent(new CustomEvent(`focus`));
  }

  emitBlur() {
    this.dispatchEvent(new CustomEvent(`blur`));
  }

  emitChange() {
    const detail = formatDate(this.state.dateObj, {iso: true});
    this.dispatchEvent(new CustomEvent(`change`, {detail}));
  }

  focus() {
    this.inputEl.focus();
  }

  select() {
    this.inputEl.select();
  }

  get inputEl() {
    return this.querySelector(`input`) as HTMLInputElement;
  }
}

export const DateInputEl = defineAndMakeJsxFactory(`mp-date-input`, DateInput);
export const DateInputReact = panel2react(`mp-date-input`, DateInput);
